var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"download-block"},[_c('a',{attrs:{"href":_vm.href}},[_c('iconized',{attrs:{"icon":_vm.icon}},[_vm._v(_vm._s(_vm.$dt(_vm.title)))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }